export var RedirectOrigins;
(function (RedirectOrigins) {
    RedirectOrigins["MY_ACCOUNT"] = "my-account";
    RedirectOrigins["ENQUIRY"] = "enquiry";
    RedirectOrigins["ORDERS"] = "orders";
    RedirectOrigins["RESERVATIONS"] = "reservations";
    RedirectOrigins["SAVED_CARS"] = "saved-cars";
    RedirectOrigins["STOCK_LOCATOR"] = "stock-locator";
})(RedirectOrigins || (RedirectOrigins = {}));
//# sourceMappingURL=RedirectOrigins.js.map